import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      {/* "GAB" text centered in hex */}
      <text
        x="50"
        y="58"
        textAnchor="middle"
        fontSize="20"
        fontFamily="Verdana, sans-serif"
        fill="currentColor"
        fontWeight="bold">
        GAB
      </text>
    </g>
  </svg>
);

export default IconLoader;
